// eslint-disable-next-line import/prefer-default-export
export const rowStyles = "h-12 py-2 px-4 flex items-center";
